<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>預算分配</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>預算分配</span></li>
          <li><span>已用預算</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">總預算</h2>
            </header>
            <div class="panel-body">
              <div align="left">　
                類　　型：<span style="color:#0000CC;">生活 </span>
              </div>
              <div align="left">　
                單位名稱：<span style="color:#FF0000;">{{deptName}} </span>
              </div>
              <div class="s_tenr">
                <table class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" width="6%">學年度</th>
                      <th class="text-center" width="10%">生活助學01</th>
                      <th class="text-center" width="10%">生活助學02</th>
                      <th class="text-center" width="15%">匯入日期</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="學年度" class="text-center">{{item.schYear}}</td>
                      <td data-title="生活助學01" class="text-center">{{item.bursary1 | numberWithCommas}}</td>
                      <td data-title="生活助學02" class="text-center">{{item.bursary2 | numberWithCommas}}</td>
                      <td data-title="匯入日期" class="text-center">{{item.createDate}}</td>
                    </tr>
                  </tbody>
                </table>
                <div align="center">
                  <br><a href="#" @click.prevent="routerBack" class="btn-upload btn btn-primary" style="background-color:#9e9e9e; border-color:#858484;">返回</a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      deptName: null
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.$http.get("/api/budget/total-budget-study/" + this.id).then(a => {
      this.list = a.body;
      this.deptName = this.list[0].deptName;
    });
  },
  methods: {
    routerBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>